import React from 'react'
import InputBox from '../../../common/InputBox'
import Select from '../../../../../commons/Select'
import { financialYear } from '../../../../../lib/financialYear'

// TODO: These variables should be moved somewhere else and be shared as they are used in other components as well
let years = [{ value: '0', label: '0' }];
let months = [{ value: '0', label: '0' }];
for (let i = 1; i < 4; i++) {
  years.push( { value: i.toString(), label: i.toString() } )
}
years.push( { value: '>3', label: '>3' } )

for (let i = 1; i < 13; i++) {
  months.push( { value: i.toString(), label: i.toString() } )
}

class Overtime extends React.Component {
  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null
    this.props.onChange(this.props.type, {
      amount: amount,
      error: null
    })
  }

  handlePeriodYears = (year) => {
    this.props.onChange(this.props.type, { periodYears: year })
  }

  handlePeriodMonths = (month) => {
    this.props.onChange(this.props.type, { periodMonths: month })
  }

  handleFrequency = (frequency) => {
    this.props.onChange(this.props.type, { frequency: frequency })
  }

  render() {
    const {
      type,
      showPeriod,
      amount,
      frequency,
      periodMonths,
      periodYears,
      errors,
    } = this.props

    return (
      <div>
        <InputBox
          label={ `Total ${type} received in Financial Year ${financialYear().lastYear}` }
          labelClass='grey'
          type={ 'Overtime' }
          amount={ amount }
          frequency={ frequency }
          handleAmount={ this.handleAmount }
          handleFrequency={ this.handleFrequency }
          errorMessage={ errors && errors.amount }
          inputMode='numeric'
        />

        { showPeriod &&
          <div>
            <div className='grey smaller mb-1'>How long have you been receiving overtime for?</div>

            <div className='form-row'>
              <div className='col-6 col-sm-2 pb-2'>
                <Select
                  defaultValue={ periodYears || years[0].value }
                  onChange={ this.handlePeriodYears }
                  options={ years }
                />
              </div>

              <div className='col-3 col-sm-2 align-self-center pb-2'>
                <div className='text-muted'>
                  years
                </div>
              </div>

              <div className='col-6 col-sm-2 pb-2'>
                <Select
                  defaultValue={ periodMonths || months[0].value  }
                  onChange={ this.handlePeriodMonths }
                  options={ months }
                />
              </div>

              <div className='col-3 col-sm-2 align-self-center pb-2'>
                <div className='text-muted'>
                  months
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Overtime
